export interface IAnswer {
  question_id: number
  position: number[]
  answer: string
}

export class Answer {
  value: IAnswer
  next: Answer | null

  constructor(value: IAnswer) {
    this.value = value
    this.next = null
  }
}
// 单例模式
export class AnswerList {
  head: Answer | null
  tail: Answer | null
  static instance: AnswerList
  constructor() {
    this.head = null
    this.tail = null
  }

  isEmpty(): boolean {
    return this.head === null
  }

  append(value: IAnswer): void {
    if (this.find(value.question_id)) {
      this.update(value)
      return
    }
    const newNode = new Answer(value)
    if (this.isEmpty()) {
      this.head = newNode
      this.tail = newNode
    } else {
      if (this.tail) {
        this.tail.next = newNode
        this.tail = newNode
      }
    }
  }

  prepend(value: IAnswer): void {
    const newNode = new Answer(value)

    if (this.isEmpty()) {
      this.head = newNode
      this.tail = newNode
    } else {
      if (this.head) {
        newNode.next = this.head
        this.head = newNode
      }
    }
  }

  delete(value: IAnswer): void {
    if (this.isEmpty()) {
      return
    }

    let currentNode = this.head
    let prevNode: Answer | null = null

    while (currentNode) {
      if (currentNode.value.question_id === value.question_id) {
        if (prevNode) {
          prevNode.next = currentNode.next

          if (currentNode === this.tail) {
            this.tail = prevNode
          }
        } else {
          this.head = currentNode.next

          if (currentNode === this.tail) {
            this.tail = null
          }
        }

        break
      }

      prevNode = currentNode
      currentNode = currentNode.next
    }
  }

  find(question_id: number): Answer | null {
    if (this.isEmpty()) {
      return null
    }

    let currentNode = this.head

    while (currentNode) {
      if (currentNode.value.question_id === question_id) {
        return currentNode
      }

      currentNode = currentNode.next
    }

    return null
  }

  getAnswerList(question_ids: number[]): IAnswer[] {
    const list: IAnswer[] = []
    let currentNode = this.head
    while (currentNode) {
      list.push(currentNode.value)
      currentNode = currentNode.next
    }
    return list.filter((item) => {
      return question_ids.includes(item.question_id)
    })
  }

  update(value: IAnswer): void {
    if (this.isEmpty()) {
      return
    }
    const { question_id } = value
    let currentNode = this.head
    while (currentNode) {
      if (currentNode.value.question_id === question_id) {
        currentNode.value = value
        break
      }
      currentNode = currentNode.next
    }
  }

  static getInstance(): AnswerList {
    if (!AnswerList.instance) {
      AnswerList.instance = new AnswerList()
    }
    return AnswerList.instance
  }
}
export const nodeList = AnswerList.getInstance()
